import { render, staticRenderFns } from "./PelatihanReportResultPretest.vue?vue&type=template&id=858c4cc8"
import script from "./PelatihanReportResultPretest.vue?vue&type=script&lang=js"
export * from "./PelatihanReportResultPretest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports